webpackJsonp([3],{

/***/ 0:
/***/ (function(module, exports) {

module.exports = Vue;

/***/ }),

/***/ "0+am":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/certification@2x.b42e1c6.png";

/***/ }),

/***/ "0La8":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ushk-rili_content J_rili_content"
  }, [_c('div', {
    staticClass: "ushk-rili_content-h"
  }, [_c('h3', {
    staticClass: "ushk-rili_content-title"
  }, [_c('span'), _vm._v(_vm._s(_vm.option.title))]), _vm._v(" "), (['港股时段', '美股盘前', '美股盘后'].includes(_vm.option.title)) ? _c('p', {
    staticClass: "ushk-rili_content-desc"
  }, [_vm._v("EPS采用的是归属于股东/母公司、（稀释后）每股收益；净利润采用的是GAAP/IFRS会计准则下的净利润")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "ushk-rili_content-b"
  }, [_c('div', {
    staticClass: "ushk-table"
  }, [_c('div', {
    staticClass: "ushk-table-head J_rili_table_head"
  }, [_c('div', {
    attrs: {
      "data-type": "fixed"
    }
  }, [_c('div', {
    staticClass: "ushk-table-head_wrap"
  }, _vm._l((_vm.option.items), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "ushk-table-head_item",
      style: ({
        width: item[1]
      })
    }, [_vm._v("\n              " + _vm._s(item[0]) + "\n            ")])
  }), 0)])]), _vm._v(" "), _c('table', {
    staticClass: "ushk-table_body"
  }, [_c('colgroup', _vm._l((_vm.option.items), function(item, index) {
    return _c('col', {
      key: index,
      attrs: {
        "width": item[1]
      }
    })
  }), 0), _vm._v(" "), _c(_vm.option.name, {
    tag: "component",
    attrs: {
      "datas": _vm.datas,
      "none-text": _vm.option.noneText,
      "type": _vm.option.type
    }
  })], 1)])])])
},staticRenderFns: []}

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 3:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("j1ja");
module.exports = __webpack_require__("UXZY");


/***/ }),

/***/ "4NHL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    datas: {
      type: [Array, Boolean],
      default: false
    },
    noneText: {
      type: String,
      default: '今日无重要经济数据'
    },
    type: String
  },
  computed: {
    isStock: function isStock() {
      return this.type.indexOf('stock') !== -1;
    }
  },
  data: function data() {
    return {};
  },

  methods: {
    moneyUnit: function moneyUnit(unit) {
      return this.isStock && unit !== '%' ? unit : '';
    }
  }
});

/***/ }),

/***/ "4R6w":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/icon-1.df1ecde.png";

/***/ }),

/***/ "4YrG":
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("4NHL"),
  /* template */
  __webpack_require__("YC7w"),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "61PB":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/accessData.a69fc55.png";

/***/ }),

/***/ "7wek":
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("8atw"),
  /* template */
  __webpack_require__("JDz3"),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "8Izg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__EconomicsList__ = __webpack_require__("BwoL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__EconomicsList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__EconomicsList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EventsList__ = __webpack_require__("pxZ2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EventsList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__EventsList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__HolidayList__ = __webpack_require__("Jjtr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__HolidayList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__HolidayList__);





/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    EconomicsList: __WEBPACK_IMPORTED_MODULE_0__EconomicsList___default.a,
    EventsList: __WEBPACK_IMPORTED_MODULE_1__EventsList___default.a,
    HolidayList: __WEBPACK_IMPORTED_MODULE_2__HolidayList___default.a
  },
  props: {
    economicsDatas: {
      type: [Array, Boolean],
      default: false
    },
    eventsDatas: {
      type: [Array, Boolean],
      default: false
    },
    stockPre: {
      type: [Array, Boolean],
      default: false
    },
    stockAfter: {
      type: [Array, Boolean],
      default: false
    },
    stockHk: {
      type: [Array, Boolean],
      default: false
    },
    holidayDatas: {
      type: [Array, Boolean],
      default: false
    },
    active: {
      type: String,
      default: 'economics'
    }
  }
});

/***/ }),

/***/ "8atw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__commons_fetch__ = __webpack_require__("yR7j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commons_config__ = __webpack_require__("13m2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__commons_utils__ = __webpack_require__("j+bc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__commons_kind__ = __webpack_require__("nlLt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__plugins_socket__ = __webpack_require__("uWYQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__commons_headers__ = __webpack_require__("+mDD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuex__ = __webpack_require__("NYxO");












var _createNamespacedHelp = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_vuex__["b" /* createNamespacedHelpers */])('calendar'),
    mapActions = _createNamespacedHelp.mapActions,
    mapGetters = _createNamespacedHelp.mapGetters;

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Calendar',
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, mapGetters(['stockAffect'])),
  data: function data() {
    return {
      curDatas: {
        economics: [],
        stockAfter: [],
        stockPre: [],
        stockHk: [],
        events: [],
        holiday: []
      },
      datas: {
        economics: [],
        stockHk: [],
        stockPre: [],
        stockAfter: [],
        events: [],
        holiday: []
      },
      curDate: new Date(),
      socket: null,
      active: 'economics',
      tabs: [{
        type: 'economics',
        name: '数据'
      }, {
        type: 'stockAfter',
        name: '美股盘后'
      }, {
        type: 'stockPre',
        name: '美股盘前'
      }, {
        type: 'stockHk',
        name: '港股时段'
      }, {
        type: 'events',
        name: '事件'
      }, {
        type: 'holiday',
        name: '假期'
      }]
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.getCurDate();
    this.getStockAffect().then(function () {
      _this.render();
      _this.initSocket();
    });
    window.testUpdate = this.update;
  },

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, mapActions(['getStockAffect']), {
    update: function update(res) {
      var type = res.type,
          data = res.data,
          action = res.action;

      if (action === 6) {
        var time = Math.floor(Math.random() * 30 + 1) - 1;
        setTimeout(function () {
          window.location.reload();
        }, time * 1000);
        return false;
      }
      if (type !== 1) {
        return false;
      }
      var data_id = data.data_id;

      var _genClassName = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__commons_kind__["a" /* genClassName */])(data, this.stockAffect),
          statusClass = _genClassName.statusClass,
          statusName = _genClassName.statusName;

      data.dataId = data_id;
      data.time_show = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__commons_utils__["c" /* dateFormat */])(data.pub_time, 'hh:mm');
      var economicsIndex = this.findData(this.datas.economics, data_id);
      var stockPreIndex = this.findData(this.datas.stockPre, data_id);
      var stockAfterIndex = this.findData(this.datas.stockAfter, data_id);
      var stockHkIndex = this.findData(this.datas.stockHk, data_id);
      var curStockPreIndex = this.findData(this.curDatas.stockPre, data_id);
      var curStockAfterIndex = this.findData(this.curDatas.stockAfter, data_id);
      var curStockHkIndex = this.findData(this.curDatas.stockHk, data_id);
      var curEconomicsIndex = this.findData(this.curDatas.economics, data_id);
      data.status_class = statusClass;
      data.status_name = statusName;
      economicsIndex !== -1 && this.$set(this.datas.economics, economicsIndex, data);
      stockPreIndex !== -1 && this.$set(this.datas.stockPre, stockPreIndex, data);
      stockAfterIndex !== -1 && this.$set(this.datas.stockAfter, stockAfterIndex, data);
      stockHkIndex !== -1 && this.$set(this.datas.stockHk, stockHkIndex, data);
      curStockPreIndex !== -1 && this.$set(this.curDatas.stockPre, curStockPreIndex, data);
      curStockAfterIndex !== -1 && this.$set(this.curDatas.stockAfter, curStockAfterIndex, data);
      curStockHkIndex !== -1 && this.$set(this.curDatas.stockHk, curStockHkIndex, data);
      curEconomicsIndex !== -1 && this.$set(this.curDatas.economics, curEconomicsIndex, data);
    },
    initSocket: function initSocket() {
      var _this2 = this;

      this.socket = new __WEBPACK_IMPORTED_MODULE_6__plugins_socket__["a" /* default */]({
        jsUrl: '//www.jin10.com/js/flash.js',
        jsName: 'flashArr',
        callback: function callback(socket) {
          socket.on('connect', function () {
            socket.emit('switch_channel', 3, console.log);
          });
          socket.on('flash', function (msg) {
            _this2.update(msg);
          });
        }
      });
    },
    filterChange: function filterChange(_ref) {
      var type = _ref.type,
          name = _ref.name;

      var datas = this.curDatas;
      for (var key in datas) {
        this.datas[key] = this.filterType(datas[key], name.replace(/ /g, ''), type);
      }
    },
    filterType: function filterType(datas, name, type) {
      var i = 0;
      var l = datas.length;
      var allData = [];
      if (type === 'all') {
        allData = datas;
      } else {
        for (; i < l; i++) {
          if (type === 'country') {
            if (datas[i].country == name) {
              allData.push(datas[i]);
            }
          } else if (type === 'actual') {
              if (!datas[i].actual || datas.status_name === '未公布') {
                allData.push(datas[i]);
              }
            } else if (type === 'important') {
                if (datas[i].star > 2) {
                  allData.push(datas[i]);
                }
              }
        }
      }
      return allData;
    },
    findData: function findData(datas, targetValue) {
      return datas.findIndex(function (m) {
        return m.id == targetValue;
      });
    },
    onDateChange: function onDateChange(date) {
      if (date === __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__commons_utils__["e" /* getQueryString */])('date')) {
        this.init();
      } else {
        location.href = '?date=' + date;
      }
    },
    getCurDate: function getCurDate() {
      var date = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__commons_utils__["e" /* getQueryString */])('date');

      this.curDate = date ? new Date(date.replace(/-/gi, '/')) : new Date();
    },
    filterData: function filterData(datas) {
      var country = '';
      var timeShow = '';
      var l = datas.length;
      var i = 0;
      var showCountryCount = 1;
      for (; i < l; i++) {
        var oldCount = showCountryCount;
        var title = datas[i].title;
        if (country) {
          datas[i - showCountryCount].count = showCountryCount;
        }
        if (datas[i].country !== country || datas[i].country === country && datas[i].time_show !== timeShow) {
          showCountryCount = 1;
          country = datas[i].country;
          timeShow = datas[i].time_show;
          datas[i].showCountry = true;
        } else {
          datas[i].showCountry = false;
          showCountryCount += 1;
          datas[i].count = 1;
        }
        if (i === l - 1 && showCountryCount > oldCount) {
          datas[i - oldCount].count = showCountryCount;
        }
        datas[i].readButton = {};
        if (title) {
          if (title.indexOf('当周EIA原油库存') !== -1) {
            datas[i].readButton.show = true;
            datas[i].readButton.link = '//datacenter.jin10.com/reportType/dc_eia_crude_oil';
          } else if (title.indexOf('美国' + datas[i].datename + '季调后非农就业人口') !== -1) {
            datas[i].readButton.show = true;
            datas[i].readButton.link = '//datacenter.jin10.com/reportType/dc_nonfarm_payrolls';
          }
        }
      }
      return datas;
    },
    render: function render() {
      var _this3 = this;

      var hasGetStockData = false;

      var _loop = function _loop(key) {
        var isStock = key.indexOf('stock') !== -1;
        if (!hasGetStockData || !isStock) {
          _this3.getData(isStock ? 'stock' : key).then(function (data) {
            if (key === 'economics') {
              data.forEach(function (d, i) {
                var _genClassName2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__commons_kind__["a" /* genClassName */])(d, _this3.stockAffect),
                    statusClass = _genClassName2.statusClass,
                    statusName = _genClassName2.statusName;

                data[i].status_class = statusClass;
                data[i].status_name = statusName;
              });
            }
            if (isStock) {
              _this3.setStockData(data);
            } else {
              _this3.curDatas[key] = data;
              _this3.datas[key] = data;
            }
          });
        }
        if (isStock) {
          hasGetStockData = true;
        }
      };

      for (var key in this.datas) {
        _loop(key);
      }
    },
    setStockData: function setStockData(datas) {
      var _this4 = this;

      var stockPre = [];
      var stockAfter = [];
      var stockHk = [];
      datas.forEach(function (data) {
        if (data.category === 'hk') {
          stockHk.push(data);
        } else if (data.category === 'us') {
          if (data.time_show === '盘前') {
            stockPre.push(data);
          } else if (data.time_show === '盘后') {
            stockAfter.push(data);
          } else {
            if (_this4.compareTime(data.time_show, '17:00', '22:30')) {
              stockPre.push(data);
            } else if (_this4.compareTime(data.time_show, '05:00', '09:00')) {
              stockAfter.push(data);
            }
          }
        }
      });
      this.curDatas.stockPre = stockPre;
      this.curDatas.stockAfter = stockAfter;
      this.curDatas.stockHk = stockHk;
      this.datas.stockPre = stockPre;
      this.datas.stockAfter = stockAfter;
      this.datas.stockHk = stockHk;
    },
    compareTime: function compareTime(btime, stime, etime) {
      if (!btime) {
        return false;
      }

      function tranDate(time) {
        return new Date(time.replace(/-/g, '/')).getTime();
      }

      var thisDate = new Date();
      var y = thisDate.getFullYear() + '-' + (thisDate.getMonth() + 1) + '-' + thisDate.getDate() + ' ';

      var startTime = tranDate(y + stime);

      var endTime = tranDate(y + etime);
      var curTime = tranDate(y + btime);

      if (curTime < startTime || curTime > endTime) {
        return false;
      }
      return true;
    },
    getData: function getData(type) {
      var _this5 = this;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this5.isLoading = true;
        var date = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__commons_utils__["c" /* dateFormat */])(new Date(_this5.curDate), 'yyyyMMdd');
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__commons_fetch__["a" /* fetch */])({
          url: __WEBPACK_IMPORTED_MODULE_3__commons_config__["a" /* requestUrl */].rili[type],
          params: {
            date: date
          },
          type: 'get',
          useJson: true,
          headers: __WEBPACK_IMPORTED_MODULE_7__commons_headers__["a" /* calendarHeaders */],

          callback: function callback(res) {
            _this5.isLoading = false;
          },
          success: function success(res) {
            resolve(res.data);
          },
          error: function error() {
            _this5.isLoading = false;
          }
        });
      });
    }
  })
});

/***/ }),

/***/ "9eTL":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/icon-3.8d38244.png";

/***/ }),

/***/ "BwoL":
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("WFyZ"),
  /* template */
  __webpack_require__("fF67"),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "Du/2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UPDATE_USER; });
var UPDATE_USER = 'UPDATE_USER';

/***/ }),

/***/ "EL4y":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ushk-rili_filter"
  }, [_c('jin-popover', {
    ref: "filter",
    attrs: {
      "placement": "bottom-end",
      "popper-class": "ushk-rili_filter-popover",
      "transition": "zoom-in-bottom"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('div', {
    staticClass: "ushk-rili_filter-box"
  }, [_c('div', {
    staticClass: "ushk-rili_filter-item"
  }, [_c('h3', {
    staticClass: "ushk-rili_filter-title"
  }, [_vm._v("状 态")]), _vm._v(" "), _c('div', {
    staticClass: "ushk-rili_filter-list"
  }, _vm._l((_vm.states), function(state, index) {
    return _c('a', {
      key: index,
      staticClass: "ushk-rili_filter-btn",
      class: {
        'active': state.name === _vm.curName
      },
      attrs: {
        "href": state.href ? state.href : 'javascript:;'
      },
      on: {
        "click": function($event) {
          return _vm.change(state.type, state.name)
        }
      }
    }, [_vm._v(_vm._s(state.name))])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "ushk-rili_filter-item"
  }, [_c('h3', {
    staticClass: "ushk-rili_filter-title"
  }, [_vm._v("按照国家/地区条件查询")]), _vm._v(" "), _vm._l((_vm.countrys), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "l-cell"
    }, [_c('div', {
      staticClass: "l-cell_item ushk-rili_filter-l"
    }, [_c('h4', [_vm._v(_vm._s(item.region))])]), _vm._v(" "), _c('div', {
      staticClass: "l-cell_item ushk-rili_filter-r"
    }, [_c('div', {
      staticClass: "ushk-rili_filter-list"
    }, _vm._l((item.datas), function(name, nameIndex) {
      return _c('a', {
        key: nameIndex,
        staticClass: "ushk-rili_filter-btn",
        class: {
          'active': name === _vm.curName
        },
        attrs: {
          "href": "javascript:;"
        },
        on: {
          "click": function($event) {
            return _vm.change(item.type, name)
          }
        }
      }, [_vm._v(_vm._s(name))])
    }), 0)])])
  })], 2)])]), _vm._v(" "), _c('a', {
    directives: [{
      name: "popover",
      rawName: "v-popover:filter",
      arg: "filter"
    }],
    class: {
      'is-active': _vm.visible
    },
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.curName))]), _vm._v(" "), _c('i', {
    staticClass: "ushk-icon ushk-icon_triangle"
  })])], 1)
},staticRenderFns: []}

/***/ }),

/***/ "F74U":
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("mYde"),
  /* template */
  __webpack_require__("se+W"),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "GhOs":
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("8Izg"),
  /* template */
  __webpack_require__("zXvW"),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "IcnI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__("mUbh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__getters__ = __webpack_require__("UjVw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mutations__ = __webpack_require__("ukYY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_home__ = __webpack_require__("xQAn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_video__ = __webpack_require__("qLZl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modules_calendar__ = __webpack_require__("Tmzm");









if (false) {
  Vue.use(Vuex);
}

var state = {
  user: {},
  isVideoPlaying: false,
  videoType: 'index'
};

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  state: state,
  actions: __WEBPACK_IMPORTED_MODULE_2__actions__,
  getters: __WEBPACK_IMPORTED_MODULE_3__getters__,
  mutations: __WEBPACK_IMPORTED_MODULE_4__mutations__["a" /* default */],
  modules: {
    home: __WEBPACK_IMPORTED_MODULE_5__modules_home__["a" /* default */],
    video: __WEBPACK_IMPORTED_MODULE_6__modules_video__["a" /* default */],
    calendar: __WEBPACK_IMPORTED_MODULE_7__modules_calendar__["a" /* default */]
  }
}));

/***/ }),

/***/ "JDz3":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ushk-content"
  }, [_c('div', {
    staticClass: "ushk-main ushk-content-box"
  }, [_c('div', {
    staticClass: "ushk-rili"
  }, [_c('div', {
    staticClass: "ushk-rili_header"
  }, [_c('div', {
    staticClass: "ushk-rili_tab"
  }, [_c('ul', {
    staticClass: "ushk-rili_tab-list"
  }, _vm._l((_vm.tabs), function(item, index) {
    return _c('li', {
      key: index,
      staticClass: "ushk-rili_tab-item",
      class: {
        'active': item.type === _vm.active
      },
      on: {
        "click": function($event) {
          _vm.active = item.type
        }
      }
    }, [_vm._v(_vm._s(item.name))])
  }), 0)]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), (_vm.curDate) ? _c('week', {
    attrs: {
      "date": _vm.curDate
    },
    on: {
      "dateChange": _vm.onDateChange
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "ushk-rili_body"
  }, [_c('list-filter', {
    on: {
      "change": _vm.filterChange
    }
  }), _vm._v(" "), _vm._l((_vm.datas), function(item, key) {
    return _c('list-group', {
      key: key,
      attrs: {
        "type": key,
        "datas": item
      }
    })
  })], 2), _vm._v(" "), _c('mobile-content', {
    attrs: {
      "economics-datas": _vm.datas.economics,
      "stock-after": _vm.datas.stockAfter,
      "stock-pre": _vm.datas.stockPre,
      "stock-hk": _vm.datas.stockHk,
      "eventsDatas": _vm.datas.events,
      "holiday-datas": _vm.datas.holiday,
      "active": _vm.active
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "ushk-side"
  }, [_c('div', {
    staticClass: "ushk-side__wrap"
  }, [_c('ad', {
    attrs: {
      "paddingTop": false
    }
  }), _vm._v(" "), _c('contract'), _vm._v(" "), _c('Declatration')], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ushk-rili_header-btn"
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('i', {
    staticClass: "ushk-icon ushk-icon_calendar1"
  })])])
}]}

/***/ }),

/***/ "Jjtr":
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("bmbP"),
  /* template */
  __webpack_require__("oI9G"),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "S/6/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__commons_utils_date_util__ = __webpack_require__("8Yka");



var ONE_DAY = 8.64e7;
var WEEKS = ['日', '一', '二', '三', '四', '五', '六'];

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    date: {
      type: Date,
      default: function _default() {
        return new Date();
      }
    }
  },
  data: function data() {
    return {
      displayDate: this.date,
      weeks: [],
      nextWeeks: [],
      preWeeks: [],
      isShowPrevWeek: false,
      isShowNextWeek: false
    };
  },

  watch: {
    date: function date(val) {
      if (val.format('yyyyMMdd') === this.displayDate.format('yyyyMMdd')) {
        return false;
      }

      this.displayDate = val;
    }
  },
  computed: {
    days: function days() {
      var currentDate = this.displayDate;
      var timestamp = currentDate.getTime();
      var currentDay = currentDate.getDay();
      var days = [];
      for (var i = 0; i < 7; i++) {
        var date = new Date(timestamp + ONE_DAY * (i - (currentDay + 6) % 7));
        days.push({
          date: date,
          weekText: '' + WEEKS[date.getDay()],
          dateText: '' + date.format('MM-dd'),
          dayText: '' + date.format('dd'),
          key: date.format('yyyyMMdd')
        });
      }
      return days;
    }
  },
  created: function created() {},

  methods: {
    onDateClick: function onDateClick(date) {
      var dateStr = date.format('yyyy-MM-dd');
      this.$emit('dateChange', dateStr);
    },
    onDateChange: function onDateChange(date) {
      location.href = '?date=' + date.format('yyyy-MM-dd');
    },
    showPrevWeek: function showPrevWeek() {
      this.displayDate = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__commons_utils_date_util__["g" /* prevDate */])(this.displayDate, 7);
    },
    showNextWeek: function showNextWeek() {
      this.displayDate = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__commons_utils_date_util__["h" /* nextDate */])(this.displayDate, 7);
    },
    isActive: function isActive(date) {
      var DATE_FORMAT = 'yyyyMMdd';
      return this.date.format(DATE_FORMAT) === date.format(DATE_FORMAT);
    }
  }
});

/***/ }),

/***/ "SzGG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__EconomicsList__ = __webpack_require__("4YrG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__EconomicsList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__EconomicsList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EventsList__ = __webpack_require__("WWZ4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EventsList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__EventsList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__HolidayList__ = __webpack_require__("F74U");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__HolidayList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__HolidayList__);





/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    EconomicsList: __WEBPACK_IMPORTED_MODULE_0__EconomicsList___default.a,
    EventsList: __WEBPACK_IMPORTED_MODULE_1__EventsList___default.a,
    HolidayList: __WEBPACK_IMPORTED_MODULE_2__HolidayList___default.a
  },
  props: {
    datas: {
      type: [Array, Boolean],
      default: false
    },
    type: String
  },
  data: function data() {
    return {
      options: {
        economics: {
          title: '经济数据一览',
          name: 'EconomicsList',
          isFilter: true,
          type: 'economics',
          items: [['时间', '7%'], ['国/区', '5%'], ['指标名称', '34%'], ['重要性', '10%'], ['前值', '8%'], ['预测值', '8%'], ['公布值', '9%'], ['影响', '13%']]
        },
        stockHk: {
          title: '港股时段',
          name: 'EconomicsList',
          type: 'stock',
          noneText: '今日无股票财报数据',
          items: [['时间', '7%'], ['交易所', '8%'], ['指标名称', '31%'], ['重要性', '10%'], ['前值', '8%'], ['预测值', '8%'], ['公布值', '9%'], ['影响', '13%']]
        },
        stockPre: {
          title: '美股盘前',
          name: 'EconomicsList',
          type: 'stock',
          noneText: '今日无股票财报数据',
          items: [['时间', '7%'], ['交易所', '8%'], ['指标名称', '31%'], ['重要性', '10%'], ['前值', '8%'], ['预测值', '8%'], ['公布值', '9%'], ['影响', '13%']]
        },
        stockAfter: {
          title: '美股盘后',
          name: 'EconomicsList',
          type: 'stock',
          noneText: '今日无股票财报数据',
          items: [['时间', '7%'], ['交易所', '8%'], ['指标名称', '31%'], ['重要性', '10%'], ['前值', '8%'], ['预测值', '8%'], ['公布值', '9%'], ['影响', '13%']]
        },
        events: {
          title: '财经大事一览',
          name: 'EventsList',
          type: 'events',
          items: [['时间', '8%'], ['国/区', '10%'], ['城市', '15%'], ['重要性', '12%'], ['事件', '47%']]
        },
        holiday: {
          title: '假期休市一览',
          name: 'HolidayList',
          type: 'holiday',
          items: [['时间', '15%'], ['国/区', '15%'], ['市场', '20%'], ['节日名称', '15%'], ['详细安排', '35%']]
        },
        stock: {
          title: '股票财报',
          name: 'EconomicsList',
          type: 'stock',
          noneText: '今日无股票财报数据',
          items: [['时间', '7%'], ['交易所', '8%'], ['指标名称', '31%'], ['重要性', '10%'], ['前值', '8%'], ['预测值', '8%'], ['公布值', '9%'], ['影响', '13%']]
        }
      }
    };
  },

  computed: {
    option: function option() {
      return this.type ? this.options[this.type] : {};
    }
  },
  created: function created() {}
});

/***/ }),

/***/ "Tmzm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__commons_fetch__ = __webpack_require__("yR7j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__commons_config__ = __webpack_require__("13m2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commons_headers__ = __webpack_require__("+mDD");





var state = {
  stockAffect: {}
};

var getters = {
  stockAffect: function stockAffect(state) {
    return state.stockAffect;
  }
};

var actions = {
  getStockAffect: function getStockAffect(_ref) {
    var _this = this;

    var commit = _ref.commit;
    var date = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

    console.log(date);
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      _this.isLoading = true;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__commons_fetch__["a" /* fetch */])({
        url: __WEBPACK_IMPORTED_MODULE_2__commons_config__["a" /* requestUrl */].rili.stockAffect,
        params: {
          date: date
        },
        headers: __WEBPACK_IMPORTED_MODULE_3__commons_headers__["a" /* calendarHeaders */],
        type: 'GET',

        useJson: true,

        callback: function callback(_ref2) {
          var data = _ref2.data;

          commit('SET_STOCK_AFFECT', data);
          resolve(data);
        },
        success: function success(_ref3) {
          var data = _ref3.data;

          commit('SET_STOCK_AFFECT', data);
          resolve(data);
        },
        error: function error() {
          reject();
        }
      });
    });
  }
};

var mutations = {
  SET_STOCK_AFFECT: function SET_STOCK_AFFECT(state, data) {
    state.stockAffect = data;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ "UXZY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__base__ = __webpack_require__("DfDl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules__ = __webpack_require__("ylPz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__App__ = __webpack_require__("dADT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__commons_utils__ = __webpack_require__("j+bc");








var vm = null;

var init = function init() {
  __WEBPACK_IMPORTED_MODULE_0_vue___default.a.config.productionTip = false;
  __WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_3__modules__["a" /* default */]);
  window.JIN10_APP.VueComponents(__WEBPACK_IMPORTED_MODULE_0_vue___default.a);
  vm = new __WEBPACK_IMPORTED_MODULE_0_vue___default.a({
    components: { App: __WEBPACK_IMPORTED_MODULE_4__App___default.a },
    template: '<App/>',
    store: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */],
    el: '#J_ushk'
  });
};

if (false) {
  window.Vue = Vue;
  addScript('//cdn.jin10.com/assets/js/vue-components/js/index.js', function () {
    init();
  });
} else {
  init();
}

/***/ }),

/***/ "UjVw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "user", function() { return user; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "options", function() { return options; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isLogin", function() { return isLogin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isReadname", function() { return isReadname; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isVideoPlaying", function() { return isVideoPlaying; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "videoType", function() { return videoType; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);


var user = function user(state) {
  return state.user;
};

var options = function options(state) {
  return state.options;
};

var isLogin = function isLogin(state) {
  return !!__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(state.user).length;
};

var isReadname = function isReadname(state, getters) {
  return getters.isLogin && state.user.cert.name && state.user.cert.status === 1;
};

var isVideoPlaying = function isVideoPlaying(state) {
  return state.isVideoPlaying;
};

var videoType = function videoType(state) {
  return state.videoType;
};

/***/ }),

/***/ "Uq1x":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/kexinwangzhan.fcb135b.png";

/***/ }),

/***/ "VwCb":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/icon-sm.655b81d.png";

/***/ }),

/***/ "WFyZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    datas: {
      type: [Array, Boolean],
      default: false
    },
    noneText: {
      type: String,
      default: '今日无重要经济数据'
    }
  },
  data: function data() {
    return {};
  }
});

/***/ }),

/***/ "WWZ4":
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("apLa"),
  /* template */
  __webpack_require__("ymDc"),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "WfM0":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/icon-calendar.f2fd14f.png";

/***/ }),

/***/ "X05P":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    datas: {
      type: [Array, Boolean],
      default: false
    }
  },
  data: function data() {
    return {};
  }
});

/***/ }),

/***/ "YC7w":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tbody', [(!_vm.datas) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "9"
    }
  }, [_vm._v("加载中......")])]) : _vm._e(), _vm._v(" "), (_vm.datas && _vm.datas.length) ? _vm._l((_vm.datas), function(data, index) {
    return _c('tr', {
      key: index,
      class: [_vm.isStock ? ("star" + (data.star)) : (data.star > 2 ? 'important' : '')]
    }, [_c('td', {
      staticClass: "ushk-rili_content-time"
    }, [_vm._v(_vm._s(data.time_show))]), _vm._v(" "), _c('td', {
      staticClass: "ushk-table_rowspan ushk-rili_content-country"
    }, [_c('img', {
      attrs: {
        "src": ("//cdn.jin10.com/assets/img/commons/flag/" + (data.country) + ".png"),
        "width": "24",
        "height": "16",
        "border": "0"
      }
    })]), _vm._v(" "), _c('td', [_c('p', {
      staticClass: "ushk-table_alignLeft"
    }, [_vm._v("\n                    " + _vm._s(data.title) + "\n                    ")])]), _vm._v(" "), _c('td', [_c('star', {
      attrs: {
        "width": data.star
      }
    })], 1), _vm._v(" "), _c('td', [(data.revised) ? _c('div', {
      staticClass: "ushk-rili_content-previous"
    }, [_vm._v("\n                " + _vm._s(data.revised) + "\n                "), _c('span', [_vm._v("修正前"), _c('br'), _vm._v(" "), (data.previous !== null && data.previous !== '') ? [_vm._v("\n                    " + _vm._s(_vm.moneyUnit(data.unit)) + _vm._s(data.previous) + _vm._s(data.unit === '%' ? data.unit : '') + "\n                ")] : [_vm._v("\n                  ---\n                ")]], 2)]) : [(data.previous !== null && data.previous !== '') ? [_vm._v("\n                    " + _vm._s(_vm.moneyUnit(data.unit)) + _vm._s(data.previous) + _vm._s(data.unit === '%' ? data.unit : '') + "\n                ")] : [_vm._v("\n                  ---\n                ")]]], 2), _vm._v(" "), _c('td', [(data.consensus !== null && data.consensus !== '') ? [_vm._v("\n                  " + _vm._s(_vm.moneyUnit(data.unit)) + _vm._s(data.consensus) + _vm._s(data.unit === '%' ? data.unit : '') + "\n              ")] : [_vm._v("\n                ---\n              ")]], 2), _vm._v(" "), _c('td', [_c('div', {
      attrs: {
        "id": data.id
      }
    }, [(data.actual !== null && data.actual !== '') ? [_vm._v("\n                    " + _vm._s(_vm.moneyUnit(data.unit)) + _vm._s(data.actual) + _vm._s(data.unit === '%' ? data.unit : '') + "\n                  ")] : [_vm._v("\n                    未公布\n                  ")]], 2)]), _vm._v(" "), _c('td', {
      attrs: {
        "id": ("J_" + (data.id))
      }
    }, [(data.show_affect && data.country !== '中国') ? _c('div', {
      staticClass: "ushk-tag_trend"
    }, [_c('p', {
      class: data.status_class ? data.status_class : 'default'
    }, [_c('span', {
      staticClass: "ushk-btn J_kind_tag",
      attrs: {
        "data-trend": "1"
      }
    }, [(data.status_name === '未公布') ? _c('em', {
      staticClass: "J_kind_trend"
    }, [_vm._v("---")]) : [_c('em', {
      staticClass: "J_kind_trend"
    }, [_vm._v(_vm._s(data.status_name))]), _vm._v(" "), _c('i', {
      staticClass: "J_kind_trendType"
    }, [_vm._v(_vm._s(data.status_name === '影响较小' ? ' ' : '股票') + " ")])]], 2)])]) : _vm._e()])])
  }) : _c('tr', [_c('td', {
    attrs: {
      "colspan": "9"
    }
  }, [_vm._v(_vm._s(_vm.noneText))])])], 2)
},staticRenderFns: []}

/***/ }),

/***/ "YM66":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ushk ushk-calendar",
    attrs: {
      "id": "J_ushk"
    }
  }, [_c('div', {
    staticClass: "ushk-container"
  }, [_c('div', {
    staticClass: "ushk-box"
  }, [_c('ushk-header'), _vm._v(" "), _c('div', {
    staticClass: "ushk-page"
  }, [_c('div', {
    staticClass: "ushk-wrap ushk-wrap-main"
  }, [_c('home')], 1)])], 1), _vm._v(" "), _c('ushk-footer')], 1)])
},staticRenderFns: []}

/***/ }),

/***/ "ZQHk":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/icon-2.87e96ed.png";

/***/ }),

/***/ "apLa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    datas: {
      type: [Array, Boolean],
      default: false
    }
  },
  data: function data() {
    return {};
  }
});

/***/ }),

/***/ "b2RE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bmbP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    datas: {
      type: [Array, Boolean],
      default: false
    }
  },
  data: function data() {
    return {};
  }
});

/***/ }),

/***/ "dADT":
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__("b2RE")
}
var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("q30K"),
  /* template */
  __webpack_require__("YM66"),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "fF67":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "ushk-rili_list-wrap J_rili_listItem"
  }, [(!_vm.datas || !_vm.datas.length) ? _c('li', {
    staticClass: "ushk-rili_list-empty"
  }, [_c('img', {
    attrs: {
      "src": "//cdn.jin10.com/assets/img/sites/rili/empty_rili.png"
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(!_vm.datas ? '加载中......' : _vm.noneText))])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.datas), function(data, index) {
    return _c('li', {
      staticClass: "ushk-rili_list-item",
      class: {
        important: data.star > 2
      }
    }, [_c('div', {
      staticClass: "ushk-rili_list-country"
    }, [_c('img', {
      attrs: {
        "src": ("//cdn.jin10.com/assets/img/commons/flag/flash/" + (data.country) + ".png")
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "ushk-rili_list-body"
    }, [_c('div', {
      staticClass: "ushk-rili_list-h"
    }, [_c('div', {
      staticClass: "ushk-rili_list-time"
    }, [_c('i', {
      staticClass: "ushk-icon ushk-icon_time"
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(data.time_show))])]), _vm._v(" "), _c('star', {
      attrs: {
        "width": data.star
      }
    })], 1), _vm._v(" "), _c('h3', {
      staticClass: "ushk-rili_list-title"
    }, [_vm._v(_vm._s(data.title))]), _vm._v(" "), _c('div', {
      staticClass: "ushk-rili_list-info"
    }, [_c('p', [_vm._v("前值：\n              "), (data.revised !== null && data.revised !== '') ? [_vm._v("\n                " + _vm._s(data.revised) + "\n              ")] : [_vm._v("\n                " + _vm._s(data.previous) + _vm._s(data.unit === '%' ? data.unit : '') + "\n              ")]], 2), _vm._v(" "), _c('p', [_vm._v("预期：\n\n                "), (data.consensus !== null && data.consensus !== '') ? [_vm._v("\n                  " + _vm._s(data.consensus) + _vm._s(data.unit === '%' ? data.unit : '') + "\n                ")] : [_vm._v("\n                  ---\n                ")]], 2), _vm._v(" "), _c('p', [_vm._v("公布：\n                "), _c('span', {
      attrs: {
        "id": "<%= item.dataId %>"
      }
    }, [(data.actual !== null && data.actual !== '') ? [_vm._v("\n                    " + _vm._s(data.actual) + _vm._s(data.unit === '%' ? data.unit : '') + "\n                  ")] : [_vm._v("\n                    ---\n                  ")]], 2)])])]), _vm._v(" "), (data.show_affect && data.country !== '中国') ? _c('div', {
      staticClass: "ushk-rili_list-tag",
      attrs: {
        "id": "J_<%= item.dataId %>"
      }
    }, [_c('div', {
      staticClass: "ushk-tag_trend"
    }, [_c('p', {
      class: data.status_class ? data.status_class : 'default'
    }, [_c('span', {
      staticClass: "ushk-btn J_kind_tag",
      attrs: {
        "data-trend": "1"
      }
    }, [(data.status_name === '未公布') ? _c('em', {
      staticClass: "J_kind_trend"
    }, [_vm._v("---")]) : [_c('em', {
      staticClass: "J_kind_trend"
    }, [_vm._v(_vm._s(data.status_name))]), _vm._v(" "), _c('i', {
      staticClass: "J_kind_trendType"
    }, [_vm._v("股票")])]], 2)])])]) : _vm._e()])
  })], 2)
},staticRenderFns: []}

/***/ }),

/***/ "fTYF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "feRo":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/renzhenglianmeng.4c9faf7.png";

/***/ }),

/***/ "fhCV":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "ushk-rili_list-wrap J_rili_listItem"
  }, [(!_vm.datas || !_vm.datas.length) ? _c('li', {
    staticClass: "ushk-rili_list-empty"
  }, [_c('img', {
    attrs: {
      "src": "//cdn.jin10.com/assets/img/sites/rili/empty_event.png"
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(!_vm.datas ? '加载中......' : '今日无财经大事'))])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.datas), function(data, index) {
    return _c('li', {
      staticClass: "ushk-rili_list-item"
    }, [_c('div', {
      staticClass: "ushk-rili_list-country"
    }, [_c('img', {
      attrs: {
        "src": ("//cdn.jin10.com/assets/img/commons/flag/flash/" + (data.country) + ".png")
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "ushk-rili_list-body"
    }, [_c('div', {
      staticClass: "ushk-rili_list-h"
    }, [_c('div', {
      staticClass: "ushk-rili_list-time"
    }, [_c('i', {
      staticClass: "ushk-icon ushk-icon_time"
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(data.public_time))])]), _vm._v(" "), _c('star', {
      attrs: {
        "width": data.star
      }
    })], 1), _vm._v(" "), _c('h3', {
      staticClass: "ushk-rili_list-title"
    }, [_vm._v(_vm._s(data.eventcontent))])]), _vm._v(" "), _c('div', {
      staticClass: "ushk-rili_list-tag"
    }, [_c('p', {
      staticClass: "ushk-btn ushk-btn_plain-primary"
    }, [_c('i', {
      staticClass: "ushk-icon ushk-icon_time"
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(data.public_time))])])])])
  })], 2)
},staticRenderFns: []}

/***/ }),

/***/ "gBM3":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/kexinwangzhan@2x.68a19e0.png";

/***/ }),

/***/ "mUbh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getUser", function() { return getUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "showLogin", function() { return showLogin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutation_types__ = __webpack_require__("Du/2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__commons_fetch__ = __webpack_require__("yR7j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commons_config__ = __webpack_require__("13m2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__commons__ = __webpack_require__("N4+L");






var getUser = function getUser(_ref) {
  var commit = _ref.commit;

  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__commons_fetch__["a" /* fetch */])({
      type: 'jsonp',
      url: __WEBPACK_IMPORTED_MODULE_3__commons_config__["a" /* requestUrl */].ucenterInfo,
      showError: false,
      success: function success(response) {
        commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["a" /* UPDATE_USER */], response.data);
        resolve(response);
      },
      fail: function fail(response) {
        reject(response);
      }
    });
  });
};

var isShowLogin = false;
var showLogin = function showLogin(_ref2, type) {
  var commit = _ref2.commit;

  if (isShowLogin) {
    return false;
  }
  isShowLogin = true;
  setTimeout(function () {
    isShowLogin = false;
  }, 1000);
  type = type || 'login';
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__commons__["a" /* showLoginBox */])({
      embedded: type === 'embedded',
      loginCallback: function loginCallback(datas) {
        commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["a" /* UPDATE_USER */], datas.data);
        resolve();
      },
      oauthCallback: function oauthCallback() {
        getUser({ commit: commit }).then(function () {
          resolve();
        });
      },

      type: type === 'embedded' ? 'login' : type
    });
  });
};

/***/ }),

/***/ "mYde":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    datas: {
      type: [Array, Boolean],
      default: false
    }
  },
  data: function data() {
    return {};
  }
});

/***/ }),

/***/ "oI9G":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "ushk-rili_list-wrap"
  }, [(!_vm.datas || !_vm.datas.length) ? _c('li', {
    staticClass: "ushk-rili_list-empty"
  }, [_c('img', {
    attrs: {
      "src": "//cdn.jin10.com/assets/img/sites/rili/empty_holiday.png"
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(!_vm.datas ? '加载中......' : '今日无假期休市安排'))])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.datas), function(data, index) {
    return _c('li', {
      staticClass: "ushk-rili_list-item"
    }, [_c('div', {
      staticClass: "ushk-rili_list-country"
    }, [_c('img', {
      attrs: {
        "src": ("//www.ushknews.com/img/company/large/" + (data.country) + ".png")
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "ushk-rili_list-body"
    }, [_c('div', {
      staticClass: "ushk-rili_list-h"
    }, [_c('div', {
      staticClass: "ushk-rili_list-time"
    }, [_c('span', [_vm._v(_vm._s(data.holidayname))])])]), _vm._v(" "), _c('h3', {
      staticClass: "ushk-rili_list-title"
    }, [_vm._v(_vm._s(data.note))])])])
  })], 2)
},staticRenderFns: []}

/***/ }),

/***/ "pNk6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  bind: function bind(el, binding, vnode) {
    function documentHandler(e) {
      if (el.contains(e.target)) {
        return false;
      }
      if (binding.expression) {
        binding.value(e);
      }
    }
    el.__vueClickOutside__ = documentHandler;
    document.addEventListener('click', documentHandler);
  },
  update: function update() {},
  unbind: function unbind(el, binding) {
    document.removeEventListener('click', el.__vueClickOutside__);
    delete el.__vueClickOutside__;
  }
});

/***/ }),

/***/ "pxZ2":
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("X05P"),
  /* template */
  __webpack_require__("fhCV"),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "q30K":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_home__ = __webpack_require__("7wek");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__pages_home__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'appStatic',
  computed: {},
  components: {
    Home: __WEBPACK_IMPORTED_MODULE_0__pages_home___default.a
  },
  created: function created() {}
});

/***/ }),

/***/ "qLZl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutation_types__ = __webpack_require__("Du/2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__commons_utils__ = __webpack_require__("j+bc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commons_config__ = __webpack_require__("13m2");





var state = {

  list: [],
  isListEnd: false,
  orgList: []
};

var getters = {
  list: function list(state) {
    return state.list;
  },
  isListEnd: function isListEnd(state) {
    return state.isListEnd;
  }
};

var actions = {
  getList: function getList(_ref, _ref2) {
    var commit = _ref.commit;
    var page = _ref2.page,
        type = _ref2.type,
        onCompleted = _ref2.onCompleted;


    var me = this;

    if (page == 1) {

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {

        var url = __WEBPACK_IMPORTED_MODULE_3__commons_config__["a" /* requestUrl */].video.list(page, type);

        window['JQ_3c42cf2edf105ad172a61c9eef7097cc'] = window['JQ_8dfb823cd98999b77e04d61deabdb4e4'] = window["JQ_2f906963abfa705c491a32911aa449ff"] = window['JQ_8a2783ae91350e5b3078ee73418dcf1e'] = function (data) {
          data.map(function (item) {

            item.isHover = false;
            item.isPlayer = false;
            item.lazyImage = "//cdn.jin10.com/assets/img/sites/video/lazy-bg.png";
            item.isShow = false;
            item.imgUrl2 = __WEBPACK_IMPORTED_MODULE_3__commons_config__["a" /* requestUrl */].video.getEffect(item.id);
            item.isPause = true;
            item.isReset = false;
            item.isShowDesc = true;
            item.scrollTop = 0;
          });
          me.state.orgList = data;

          commit('getList', {
            data: data,
            page: page,
            onCompleted: onCompleted
          });

          resolve(data);
        };

        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__commons_utils__["a" /* addScript */])(url, function (argument) {});
      });
    } else {
      commit('getList', {
        data: me.state.orgList,
        page: page,
        onCompleted: onCompleted
      });
    }
  }
};

var pageSize = 10;

var mutations = {
  getList: function getList(state, _ref3) {
    var data = _ref3.data,
        page = _ref3.page,
        onCompleted = _ref3.onCompleted;

    state.orgList = data;
    var newData = state.orgList.concat([]);

    if (page * pageSize >= state.orgList.length) {

      state.list = state.orgList;
      state.isListEnd = true;
    } else {
      newData.length = page * pageSize;
      state.list = newData;
      state.isListEnd = false;
    }

    if (onCompleted) {

      onCompleted(data);
    }
  },
  isItemShow: function isItemShow(state, index) {

    return state.list[index].isShow;
  },
  setItemShow: function setItemShow(state, index) {

    if (!state.list[index].isShow) {
      state.list[index].isShow = true;
    }
  },
  setItemScrollTop: function setItemScrollTop(state, _ref4) {
    var index = _ref4.index,
        scrollTop = _ref4.scrollTop;

    state.list[index].scrollTop = scrollTop;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ "qNF3":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/arrow.f3906ca.png";

/***/ }),

/***/ "qNZ7":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/certification.1c5d039.png";

/***/ }),

/***/ "r5b5":
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("S/6/"),
  /* template */
  __webpack_require__("yvwG"),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "se+W":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tbody', [(!_vm.datas) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "5"
    }
  }, [_vm._v("加载中......")])]) : _vm._e(), _vm._v(" "), (_vm.datas && _vm.datas.length) ? _vm._l((_vm.datas), function(data, index) {
    return _c('tr', [_c('td', {
      staticClass: "ushk-rili_content-time"
    }, [_vm._v(_vm._s(_vm._f("dateFormat")(data.date, 'yyyy-MM-dd')))]), _vm._v(" "), _c('td', [_vm._v("\n            " + _vm._s(data.country) + "\n          ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.exchangename))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.holidayname))]), _vm._v(" "), _c('td', [_c('p', {
      staticClass: "ushk-table_alignLeft"
    }, [_vm._v(_vm._s(data.note))])])])
  }) : _c('tr', [_c('td', {
    attrs: {
      "colspan": "5"
    }
  }, [_vm._v("今日无假期休市安排")])])], 2)
},staticRenderFns: []}

/***/ }),

/***/ "ufEw":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/icon-4.550c545.png";

/***/ }),

/***/ "ukYY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutation_types__ = __webpack_require__("Du/2");


var _types$UPDATE_USER$se;


/* harmony default export */ __webpack_exports__["a"] = (_types$UPDATE_USER$se = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$UPDATE_USER$se, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["a" /* UPDATE_USER */], function (state, datas) {
  state.user = datas;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$UPDATE_USER$se, 'setVideoState', function setVideoState(state, isVideoPlaying) {

  state.isVideoPlaying = isVideoPlaying;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$UPDATE_USER$se, 'setVideoType', function setVideoType(state, type) {

  state.videoType = type;
}), _types$UPDATE_USER$se);

/***/ }),

/***/ "v2ns":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vXDa":
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("xIf2"),
  /* template */
  __webpack_require__("EL4y"),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "wTUH":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/renzhenglianmeng@2x.828f805.png";

/***/ }),

/***/ "wkRJ":
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("SzGG"),
  /* template */
  __webpack_require__("0La8"),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "xIf2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      visible: false,
      curName: '全部',
      states: [{
        type: 'all',
        name: '全部'
      }, {
        href: 'https://www.ushknews.com/calendar.html',
        name: '今日'
      }, {
        type: 'actual',
        name: '未公布'
      }, {
        type: 'important',
        name: '重要'
      }],
      countrys: [{
        region: '地 区',
        type: 'all',
        datas: ['全部']
      }, {
        region: '欧 洲',
        type: 'country',
        datas: ['欧元区', '德 国', '英 国', '法 国', '瑞 士', '意大利', '西班牙']
      }, {
        region: '北 美',
        type: 'country',
        datas: ['美 国', '加拿大']
      }, {
        region: '亚 洲',
        type: 'country',
        datas: ['中 国', '日 本', '韩 国', '印 度', '香 港', '台 湾', '新加坡']
      }, {
        region: '澳 洲',
        type: 'country',
        datas: ['澳大利亚', '新西兰']
      }]
    };
  },

  methods: {
    change: function change(type, name) {
      this.curName = name;
      this.$emit('change', {
        type: type,
        name: name
      });
      this.visible = false;
    }
  }
});

/***/ }),

/***/ "xQAn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mutation_types__ = __webpack_require__("Du/2");


var state = {};

var getters = {};

var actions = {};

var mutations = {};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ "ylPz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = install;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ListGroup__ = __webpack_require__("wkRJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ListGroup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__ListGroup__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MobileContent__ = __webpack_require__("GhOs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MobileContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__MobileContent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Week__ = __webpack_require__("r5b5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Week___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Week__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ListFilter__ = __webpack_require__("vXDa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ListFilter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__ListFilter__);







var components = {
  ListGroup: __WEBPACK_IMPORTED_MODULE_1__ListGroup___default.a,
  MobileContent: __WEBPACK_IMPORTED_MODULE_2__MobileContent___default.a,
  Week: __WEBPACK_IMPORTED_MODULE_3__Week___default.a,
  ListFilter: __WEBPACK_IMPORTED_MODULE_4__ListFilter___default.a
};

function install(Vue) {
  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(components).forEach(function (key) {
    Vue.component(key, components[key]);
  });
}

/***/ }),

/***/ "ymDc":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tbody', [(!_vm.datas) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "5"
    }
  }, [_vm._v("加载中......")])]) : _vm._e(), _vm._v(" "), (_vm.datas && _vm.datas.length) ? _vm._l((_vm.datas), function(data, index) {
    return _c('tr', {
      key: index,
      class: {
        important: data.star > 2
      }
    }, [_c('td', {
      staticClass: "ushk-rili_content-time"
    }, [_vm._v(_vm._s(data.public_time))]), _vm._v(" "), _c('td', [_vm._v("\n              " + _vm._s(data.country) + "\n            ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.city))]), _vm._v(" "), _c('td', [_c('star', {
      attrs: {
        "width": data.star
      }
    })], 1), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "l-cell"
    }, [(data.people) ? _c('p', {
      staticClass: "l-cell_item ushk-rili_content-img"
    }, [_c('img', {
      attrs: {
        "src": ("//cdn.jin10.com/images/flag/tx/" + (data.people) + ".png")
      }
    })]) : _vm._e(), _vm._v(" "), _c('p', {
      staticClass: "l-cell_item"
    }, [_vm._v("\n                        " + _vm._s(data.eventcontent) + "\n                        "), (typeof data.relates !== 'undefined' && (data.relates.news || data.relates.video || data.relates.flash)) ? _c('span', {
      staticStyle: {
        "display": "block"
      }
    }, [_vm._v("【 扩展阅读：\n                          "), (data.relates.news) ? _c('a', {
      attrs: {
        "href": ("//news.jin10.com/rili_event.html?cate=" + (data.id)),
        "target": "_blank"
      }
    }, [_vm._v("新闻 ")]) : _vm._e(), _vm._v(" "), (data.relates.video) ? _c('a', {
      attrs: {
        "href": "`//v.jin10.com/rili_event.html?cate=${data.id}`",
        "target": "_blank"
      }
    }, [_vm._v("视频 ")]) : _vm._e(), _vm._v(" "), (data.relates.flash) ? _c('a', {
      attrs: {
        "href": "`//www.jin10.com/rili_event.html?cate=${data.id}`",
        "target": "_blank"
      }
    }, [_vm._v("快讯 ")]) : _vm._e(), _vm._v("】\n                        ")]) : _vm._e()])])])])
  }) : _c('tr', [_c('td', {
    attrs: {
      "colspan": "5"
    }
  }, [_vm._v("今日无财经大事")])])], 2)
},staticRenderFns: []}

/***/ }),

/***/ "yvwG":
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ushk-rili_week calendar-wrap-card"
  }, [_c('div', {
    staticClass: "ushk-rili_calendar"
  }, [_c('UshkDatePicker', {
    attrs: {
      "value": _vm.date
    },
    on: {
      "input": _vm.onDateChange
    }
  }, [_c('div', {
    attrs: {
      "slot": "right"
    },
    slot: "right"
  }, [_vm._t("default")], 2)])], 1), _vm._v(" "), _c('div', {
    staticClass: "ushk-rili_days"
  }, [_c('a', {
    staticClass: "ushk-rili_week-btn ushk-rili_week-prev",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.showPrevWeek
    }
  }, [_c('img', {
    staticClass: "icon-left",
    attrs: {
      "src": __webpack_require__("qNF3"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v("上周")])]), _vm._v(" "), _c('ul', {
    staticClass: "ushk-rili_week-list"
  }, _vm._l((_vm.days), function(item, index) {
    return _c('li', {
      key: index,
      class: {
        active: _vm.isActive(item.date)
      }
    }, [_c('a', {
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          return _vm.onDateClick(item.date)
        }
      }
    }, [_c('div', {
      staticClass: "week-warp"
    }, [_c('span', {
      staticClass: "week week-ext"
    }, [_vm._v("周" + _vm._s(item.weekText))]), _vm._v(" "), _c('span', {
      staticClass: "dd"
    }, [_vm._v(_vm._s(item.dayText))])]), _vm._v(" "), _c('div', {
      staticClass: "dd-warp"
    }, [_c('span', {
      staticClass: "mm-dd"
    }, [_vm._v(_vm._s(item.dateText))]), _vm._v(" "), _c('span', {
      staticClass: "week"
    }, [_vm._v(_vm._s(item.weekText))])])])])
  }), 0), _vm._v(" "), _c('a', {
    staticClass: "ushk-rili_week-btn ushk-rili_week-next is-active",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.showNextWeek
    }
  }, [_c('span', [_vm._v("下周")]), _vm._v(" "), _c('img', {
    staticClass: "icon-right",
    attrs: {
      "src": __webpack_require__("qNF3"),
      "alt": ""
    }
  })])])])
},staticRenderFns: []}

/***/ }),

/***/ "zXvW":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ushk-rili_list"
  }, [(_vm.active === 'economics') ? _c('economics-list', {
    attrs: {
      "datas": _vm.economicsDatas
    }
  }) : _vm._e(), _vm._v(" "), (_vm.active === 'stockAfter') ? _c('economics-list', {
    attrs: {
      "datas": _vm.stockAfter,
      "none-text": "今日无股票财报数据"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.active === 'stockPre') ? _c('economics-list', {
    attrs: {
      "datas": _vm.stockPre,
      "none-text": "今日无股票财报数据"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.active === 'stockHk') ? _c('economics-list', {
    attrs: {
      "datas": _vm.stockHk,
      "none-text": "今日无股票财报数据"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.active === 'events') ? _c('events-list', {
    attrs: {
      "datas": _vm.eventsDatas
    }
  }) : _vm._e(), _vm._v(" "), (_vm.active === 'holiday') ? _c('holiday-list', {
    attrs: {
      "datas": _vm.holidayDatas
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ })

},[3]);


// WEBPACK FOOTER //
// static/js/calendar.468d17e7335f4a44766b.js